/**
 * Custom React hook that checks and applies custom layout styles.
 * 
 * @returns {Object} An object containing the custom layout styles.
 * @returns {boolean} customLayout.isUseHyperlinkStyle - Indicates whether the hyperlink style is applied.
 * @returns {boolean} customLayout.isUseBreadcrumbStyle - Indicates whether the breadcrumb style is applied.
 * @returns {boolean} customLayout.isUseCustomTheme - Indicates whether the custom theme is applied.
 * 
 * @example
 * const { customLayout } = useApplyCustomLayout();
 * console.log(customLayout.isUseHyperlinkStyle); // Output: true or false
 */

import { useMemo } from 'react';
import { checkApplyCustomLayout } from 'utils/function';

const useApplyCustomLayout = () => {

  const isUseHyperlinkStyle = useMemo(
    () => checkApplyCustomLayout('hyperLink') ?? false,
    [],
  );

  const isUseBreadcrumbStyle = useMemo(
    () => checkApplyCustomLayout('breadcrumb') ?? false,
    [],
  );

  const isUseCustomTheme = useMemo(
    () => checkApplyCustomLayout('themeJson') ?? false,
    [],
  );

  const customLayout = useMemo(
    () => ({
      isUseHyperlinkStyle,
      isUseBreadcrumbStyle,
      isUseCustomTheme,
    }),
    [isUseHyperlinkStyle, isUseBreadcrumbStyle, isUseCustomTheme],
  );

  return { customLayout }
};

export default useApplyCustomLayout;